import React from 'react';

const DropDown = ({ options, defaultText, value, onchange, paramkey }) => {

    const handleChange = (e) => {
        const value = e.target.value;

        if (onchange)
            onchange(value);

    };

    

    return (
        <select name={paramkey} onChange={handleChange} value={value || ""} required className="block w-full h-[40px] px-3  bg-thirdly border border-gray-500/100 text-white rounded-md " defaultValue="">
            <option value="" disabled className='text-gray'>{defaultText}</option>
            {options?.map((option, index) => (
                <option key={index} value={option?.id}>
                    {option?.name || option?.status || option?.type || option?.full_name || option?.name.en}
                </option>
            ))}
        </select>
    );
};

export default DropDown;